export const sidebarPanelNames = {

    DIRECT_FEATURE_INFO: "DirectFeatureInfoPanel",

    IKM_MAIN: "IkmMainPanel",
    IKM_FEATURE_INFO: "IkmFeatureInfoPanel",


    MAP_MODULES_LIST: "MapModulesListPanel",

    MAP_MODULE_INFO: "MapModuleInfoPanel",

    /*
    RAUMPLANUNG_QUICK_SETTINGS: "RaumplanungQuickSettings",
    IKM_QUICK_SETTINGS: "IkmQuickSettings",
    RASTER_GEODATA_QUICK_SETTINGS: "RasterGeodataQuickSettings",
*/
    RASTER_GEODATA_TIME_SERIES: "RasterGeodataTimeSeriesPanel",
    RASTER_GEODATA_VALUE_QUERY: "RasterGeodataValueQueryPanel",

    RAUMPLANUNG_MAIN: "RaumplanungMainPanel",
    RAUMPLANUNG_FEATURE_INFO: "RaumplanungFeatureInfoPanel",
    RAUMPLANUNG_FEATURES_LIST: "RaumplanungFeaturesListPanel",


    SIMPLE_GEODATA_MAIN: "SimpleGeodataMainPanel",
    SIMPLE_GEODATA_FEATURE_INFO: "SimpleGeodataFeatureInfoPanel",

    STANDARD_MODULE_MAIN: "StandardModuleDetailsPanel",

    STORYMAP_MAIN: "StoryMapMainPanel",

    RAUMPLANUNG_ATTRIBUTE_INFO: "RaumplanungAttributeInfoPanel",

    WMS_FEATURE_INFO: "WmsFeatureInfoPanel",


}